import { SCOPES } from "shared/enums/common.enum";
import { Permission } from "./permission";

export class Role {
    id!: string;
    name!: string;
    scope!: SCOPES;
    companyId!: string;
    isSystem!: boolean;
    createdAt!: string;
    updatedAt!: string;
    permissions!: Permission[];
    description!: string;

    constructor(data?: Partial<Role>) {
        Object.assign(this, data);

        if (data?.permissions) {
            this.permissions = data.permissions.map(
                p => new Permission(p)
            );
        }
    }
}